import React, { Fragment, useEffect, useState } from 'react'
import Api from '../../../inc/Api';
import Settings from '../../../inc/Settings';
import SimpleLoading from '../../Loading/SimpleLoading';
import NavigationHeder from '../../Navigations/NavigationHeder';
import LinkBtn from '../../inc/LinkBtn';
import Button from '../../inc/Button';
import Helper from '../../../inc/Helper';
import { areObjectsDifferent, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import FormValidator from '../../../inc/FormValidator';
import { useParams } from 'react-router-dom';
import Collapse from '../../inc/Collapse';
import FieldsRenderer from '../../Purchase Orders Internal/Edit PO/FieldsRenderer';
import MasterComponentWraper from '../../Backend/MasterComponentWraper';
import { connect } from 'react-redux';

let defaultApiMasterFormsObject = null;
const ApiMasterFormsDetailView = () => {
  const [apiMasterFormsData, setApiMasterFormsData] = useState({});

  const { id } = useParams();

  const [loading, setLoading] = useState(true); 
 
  let getByIdApiCall = false; 

  useEffect(() => { 
    getApiMasterFormsById();
  }, [])

  let validator;

  const validationConfigure = () => {
    let fieldConfig = [
      { name: "api_name", displayName: "Api name", types: ["Required"] },
      { name: "api_url", displayName: "Api URL", types: ["Required"] },
      { name: "api_method", displayName: "Api method", types: ["Required"] },
      { name: "api_key", displayName: "Api key", types: ["Required"] },
      { name: "api_secret", displayName: "Api secret", types: ["Required"] }, 
      { name: "api_master_id", displayName: "Api master", types: ["Required"] },
      { name: "timeout", displayName: "Timeout", types: ["Required"] },
      { name: "retry_count", displayName: "Retry count", types: ["Required"] }, 
      { name: "priority", displayName: "Priority", types: ["Required"] },
      { name: "type", displayName: "Type", types: ["Required"] },  
    ];

    if(!validator) {
      validator = new FormValidator(fieldConfig)
    }
  }

  validationConfigure()

  const getApiMasterFormsById = () => { 
    if(getByIdApiCall) return;

    getByIdApiCall = true;
    setLoading(true);

    let api = Api
    api.setUserToken()
    api.axios().get(Settings.apiAppUrl+`/api-details/${id}/`,{}).then(function(res){
      if(res?.status === 200){ 
        setApiMasterFormsData(res?.data);
        defaultApiMasterFormsObject = res?.data;
        setLoading(false);
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => { 
      getPopupMessageBasedOnStatus(res) 
      setLoading(false)
    })
  }

  const ApiMasterFormsDetailView = () => { 
    let textBoxInputSettings = [
      {
        className: "col-lg-4",
        label: "Api name",
        inputType: "text",
        id: "api_name",
        name: "api_name",
        required: true,
      }, 
      {
        className: "col-lg-4",
        label: "Api URL",
        inputType: "text",
        required: true,
        id: "api_url",
        name: "api_url",
      },
      {
        className: "col-lg-4",
        label: "Api method",
        inputType: "text",
        required: true,
        id: "api_method",
        name: "api_method",
      },
      {
        className: "col-lg-4",
        label: "Api key",
        inputType: "text",
        id: "api_key",
        name: "api_key",
        required: true,
      },
      {
        className: "col-lg-4",
        label: "Api secret",
        inputType: "text",
        id: "api_secret",
        required: true,
        name: "api_secret",
      }, 
      {
        className: "col-lg-4",
        label: "Api master",
        inputType: "number",
        id: "api_master_id",
        required: true,
        name: "api_master_id",
      }, 
      {
        className: "col-lg-4",
        label: "Timeout",
        inputType: "number", 
        required: true,
        id: "timeout",
        name: "timeout",
      },
      {
        className: "col-lg-4",
        label: "Retry count",
        inputType: "number", 
        required: true,
        id: "retry_count",
        name: "retry_count",
      },
      {
        className: "col-lg-4",
        label: "Status",
        inputType: "dropdown",
        options: Settings.enumStatus,
        required: true,
        id: "status",
        name: "status",
      },
      {
        className: "col-lg-4",
        label: "Priority",
        inputType: "number",
        required: true,
        id: "priority",
        name: "priority",
      },
      {
        className: "col-lg-4",
        label: "Type",
        inputType: "number",
        required: true,
        id: "type",
        name: "type",
      }
    ];

    return (
      <Collapse open={true} title={"General"}>
        <div className='row mb-3'>
          <FieldsRenderer fieldsArray={textBoxInputSettings} updateState={setApiMasterFormsData} currentState={apiMasterFormsData} />
        </div>
      </Collapse>
    )
  }

  const SaveHandler = () => {
    if(!areObjectsDifferent(defaultApiMasterFormsObject, apiMasterFormsData)) return;
    
    let validData = {
      ...apiMasterFormsData
    };

    if(!validator.isValid(validData)){ 
      validator.displayMessage();
      validator.reset() 
      return;
    };
  
    if (!apiMasterFormsData.status && apiMasterFormsData.status !== 0) {
      Helper.alert('Status field is required', 'error');
      return;
    };
    
    let api = Api;
    api.setUserToken();

    api.axios().put(Settings.apiAppUrl+`/api-details/${id}/`, apiMasterFormsData).then(function(res){
      if(res?.status === 200){
        Helper.alert(res?.data?.message || 'Api master updated successfully', 'success');
        getApiMasterFormsById();
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    }).catch((res) => {  
      getPopupMessageBasedOnStatus(res);
    })  
  }

  return (
    <div className='container-fluid'>
      <NavigationHeder title={ `<span style="color:#000;"> Edit Api Master #</span> ${apiMasterFormsData.api_name}` }>
        <LinkBtn to={-1} isActive= {false} title={"Close"} />
        <Button isActive= {true} onClick ={SaveHandler} title={"Save"} icon={'/images/icons/save-white.svg'} />
      </NavigationHeder>

      {loading ? <SimpleLoading /> : (
        <Fragment>
          {ApiMasterFormsDetailView()} 
        </Fragment>
      )} 
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    auth:state.auth
  }
}
 
export default connect(mapStateToProps) (MasterComponentWraper(ApiMasterFormsDetailView));  